// extracted by mini-css-extract-plugin
export var aggregationCell = "_2p-t";
export var aggregationRow = "_2p-s";
export var borderlessSpinnerContainer = "_2p-3";
export var cardLayout = "_2p-6";
export var cardLayoutNoFooter = "_2p-a";
export var cardLayoutPageControl = "_2p-9";
export var cardLayoutWithFooter = "_2p-8";
export var closeIcon = "_2p-l";
export var columnHeaderSurface = "_2p-d";
export var columnHeaderSurfaceDragOverlay = "_2p-11";
export var columnHeaderSurfaceResizing = "_2p-y";
export var contextMenuAnchor = "_2p-1";
export var draggableColumnHeader = "_2p-z";
export var draggableColumnHeaderOverlay = "_2p-10";
export var expandIcon = "_2p-m";
export var expanded = "_2p-n";
export var filterBackIcon = "_2p-g";
export var filterButtonAnchor = "_2p-f";
export var filterDropdown = "_2p-o";
export var filterDropdownDivider = "_2p-j";
export var filterDropdownHeader = "_2p-r";
export var filterDropdownItem = "_2p-q";
export var filterDropdownModal = "_2p-p _2p-o";
export var filterItem = "_2p-e";
export var normalCellWithAdjustableBorder = "_2p-k";
export var pinButtonContainer = "_2p-u";
export var pinIcon = "_2p-v";
export var pinIconActive = "_2p-w";
export var spinner = "_2p-0";
export var spinnerContainer = "_2p-2";
export var subFilterArrowIcon = "_2p-h";
export var tableContainer = "_2p-4";
export var tableContentDraggingColumns = "_2p-c";
export var tableContentInner = "_2p-7";
export var tableContentInnerFill = "_2p-b";
export var tableContentWrapper = "_2p-5";
export var toolbarEnd = "_2p-i";
export var viewButtonContainer = "_2p-x";